import { render } from "./EventTopRanking.vue?vue&type=template&id=d27bf3d2&scoped=true"
import script from "./EventTopRanking.vue?vue&type=script&lang=js"
export * from "./EventTopRanking.vue?vue&type=script&lang=js"

import "./EventTopRanking.vue?vue&type=style&index=0&id=d27bf3d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d27bf3d2"]])

export default __exports__